import Button from '@components/Button';
import Map from '@components/Map';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { useFlow } from '@router/stackflow';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import useOnBoundChange from './hooks/useOnBoundChange';
import { locationAgreedAtom, userLatLonAtom } from '../../../atoms/shopsInMapAtoms';

interface Props {
    markers?: MarkerProps[];
    isOrder?: boolean;
    next?: string;
}

function ShopMap({ markers, isOrder }:Props) {
    const { push } = useFlow();
    const { t } = useTranslation('shopList');

    const handleMarkerClick = (
        id?: string,
        lat?: number,
        lng?: number,
    ) => {
        if (isOrder) {
            push('ShopLocationBottomSheet', {
                shopId: id!,
                lat,
                lng,
            });
        } else {
            push('ShopDetailBottomSheet', {
                shopId: id!,
            });
        }
    };
    const onBoundChange = useOnBoundChange();
    const location = useAtomValue(userLatLonAtom);
    const locationAgreed = useAtomValue(locationAgreedAtom);
    const project = useProject();
    const defaultLocation = { lat: project?.lat || 37.4811291019439, lng: project?.lon || 126.895303784633 };
    return (
        <Container>
            <Map center={(location.lat !== 0 && locationAgreed) ? {
                lat: location.lat,
                lng: location.lon,
            } : defaultLocation}
            height={326}
            onMarkerClick={handleMarkerClick}
            onBoundChange={onBoundChange}
            showMyLocation={locationAgreed}
            markers={markers} />
            {(!locationAgreed) && (
                <AgreeButton
                    onClick={() => push('AccountSettingActivity', {})}
                    size='sm'>
                    {t('map.locationConsent')}
                </AgreeButton>
            )}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    width: 100%;
    height: 326px;
    max-height: 326px;
    min-height: 326px;
    position: relative;
    justify-content: center;
`;

const AgreeButton = styled(Button)`
    height: 36px !important;
    padding: 6px 12px !important;
    border-radius: 15px;
    position: absolute;
    bottom: 12px;
`;

export default ShopMap;
